export default "__VITE_ASSET__Dtc_DTqN__"